import React, { memo, useEffect, useState } from 'react';
import { useTranslation } from 'next-i18next';
import ServiceWrapper from './serviceWrapper';
import styles from '../styles/configuration.module.scss';
import InputComponent from './inputComponent';
import { Dropdown } from 'react-dropdown-now';
import 'react-dropdown-now/style.css';

function DiskConfig({ service, changeConfigurations, intialConfigs, storage }) {
    const { t } = useTranslation('configuration');

    const [isCheck, setIsCheck] = useState(intialConfigs.isCheck);
    const [users, setUsers] = useState(intialConfigs.users);
    const [space, setSpace] = useState(intialConfigs.space);
    const [usable, setUsable] = useState(parseFloat(intialConfigs.space * storage.total / 100).toFixed(1));
    const [isMount, setIsMount] = useState(false);
    const [isHidden, setIsHidden] = useState(true);

    useEffect(() => {
        if (isMount) {
            changeConfigurations({ users, space, usable, isCheck });
        }
    }, [isCheck, users, space, usable]);

    useEffect(() => {
        setUsable(parseFloat(space * storage.total / 100).toFixed(1));
    }, [space, storage]);

    useEffect(() => {
        setIsMount(true);
    }, []);

    useEffect(() => {
        if (!isCheck) {
            setSpace(0);
        }
    }, [isCheck]);

    return (
        <ServiceWrapper service={service} value={isCheck} changeActivity={value => setIsCheck(value)}>
            <div className={'flex ' + styles.configs} onClick={() => setIsHidden(!isHidden)}>
                <div className={styles['arrow-container']}>
                    <div className={`${styles['arrow-element']} ${isHidden ? '' : styles['rotate-forward']}`} />
                </div>
                <p className={'pointer ' + styles.title}>{t('config')}</p>
            </div>
            <div className={`${styles[isHidden ? 'hide' : 'visible']} ${styles.options}`}>
                <div className={styles['config-wrapper']}>
                    <p className={styles.content}>{t('disk.users')}</p>
                    <Dropdown
                        disabled={!isCheck}
                        options={service.options[0].values.map((option) => ({ value: option.value, label: option.text }))}
                        onChange={(e) => setUsers(e.value)}
                        value={users || service.options[0].values[0]}
                        className={styles['dropdown-size']}
                    />
                </div>
                <InputComponent label={'disk.space'}
                            initial={space}
                            free={storage.free}
                            usable={storage.total}
                            setSpace={size => setSpace(size)}
                            available={isCheck} />
            </div>
            <style jsx>{`
                select {
                    width: 110px;
                }
            `}</style>
        </ServiceWrapper>
    )
};

export default memo(DiskConfig);
